module.exports = __webpack_public_path__ + "assets/img/6.f0dcecd6.png";